import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import ClientReport from '../clients/ClientReport';
import FabricReport from '../fabrics/FabricReport';
import SummaryReport from '../summary/SummaryReport';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function MainReport(props) {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Summary" {...a11yProps(0)} style={{ textTransform: 'none', }} />
                    <Tab label="Client Report" {...a11yProps(1)} style={{ textTransform: 'none', }} />
                    <Tab label="Fabric Report" {...a11yProps(2)} style={{ textTransform: 'none', }} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <h3>Summary</h3>
                <SummaryReport />

            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <h3>Client Report</h3>
                <ClientReport />

            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <h3>Fabric Report</h3>
                <FabricReport />
            </CustomTabPanel>

        </Box>
    );
}

